import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  width: 20px;
  height: 21px;
`

export const PassengerWithSeatIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M12.9167 16.9349H6.25C5.90625 16.9349 5.61198 16.8125 5.36719 16.5677C5.1224 16.3229 5 16.0286 5 15.6849V6.08073H6.25V15.6849H12.9167V16.9349ZM9.125 5.53906C8.65278 5.53906 8.25347 5.37587 7.92708 5.04948C7.60069 4.72309 7.4375 4.32378 7.4375 3.85156C7.4375 3.37934 7.60069 2.98003 7.92708 2.65365C8.25347 2.32726 8.65278 2.16406 9.125 2.16406C9.59722 2.16406 9.99653 2.32726 10.3229 2.65365C10.6493 2.98003 10.8125 3.37934 10.8125 3.85156C10.8125 4.32378 10.6493 4.72309 10.3229 5.04948C9.99653 5.37587 9.59722 5.53906 9.125 5.53906ZM13.75 18.8307V14.8516H8.64583C8.21614 14.8516 7.8483 14.7006 7.54231 14.3987C7.23633 14.0968 7.08333 13.7339 7.08333 13.3099V8.5599C7.08333 7.99406 7.28047 7.5158 7.67473 7.1251C8.06901 6.73441 8.55165 6.53906 9.12265 6.53906C9.69366 6.53906 10.1771 6.73441 10.5729 7.1251C10.9688 7.5158 11.1667 7.99406 11.1667 8.5599V12.7682H13.4375C13.8672 12.7682 14.235 12.9192 14.541 13.2211C14.847 13.523 15 13.8859 15 14.3099V18.8307H13.75Z" />
    </Svg>
  )
}
